import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {DraftMessageModel} from '../../../../models/api/messageModel';
import {AppState} from '../../../../store/appState';
import {makeGetAuthor, makeGetIsUserAuthor} from '../../../../store/data/messages/messagesSelectors';
import {MessageComposer} from './messageComposer';

/*
 * Props.
 */

interface MessageComposerContainerProps {
  message: DraftMessageModel;
}

/*
 * Selectors.
 */

function getMessage(_state: AppState, props: MessageComposerContainerProps) {
  return props.message;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<MessageComposerContainerProps>()(() => {
  const getAuthor = makeGetAuthor(getMessage);
  const getIsUserAuthor = makeGetIsUserAuthor(getAuthor);

  return {
    author: getAuthor,
    isUserAuthor: getIsUserAuthor,
  };
});

export const MessageComposerContainer = connect(mapStateToProps)(MessageComposer);
